$(document).ready(function() {
  var elem = document.querySelector(".seccion-checkout.seccion-checkout-servicios");
  if (elem == null) {
    return;
  }

  var intervals = {}

  let vueAppCheckoutServicios = new Vue({
    el: elem,
    data: {
      servicios: [],
      total: total
    },
    computed: {
      serviciosAgregados: function (){
        return this.servicios.filter(item => {
          return item.cantidad != null && item.cantidad+"".trim().length > 0
        })
      },
      serviciosPrecios: function (){
        let total = 0

        let serviciosAgregados = this.serviciosAgregados

        for(let index in serviciosAgregados){
          let servicio = serviciosAgregados[index]
          total += servicio.cantidad * servicio.precio
        }

        return total
      }
    },
    mounted() {
      let serviciosAgregadosUrl = []
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      let indexParam = 0
      while (params.get("servicios["+indexParam+"]") != null){
        serviciosAgregadosUrl.push(JSON.parse(params.get("servicios["+indexParam+"]")))
        indexParam++
      }

      this.servicios = Object.assign([], serviciosJson).map(item => {
        let find = serviciosAgregadosUrl.find((itemUrl) => itemUrl.servicio_id == item.id)
        let cantidad = null
        if(find != null){
          cantidad = parseInt(find.cantidad)
          if(isNaN(cantidad)){
            cantidad = null
          }
        }
        item.cantidad = cantidad
        return item
      })

      setTimeout(() => {
        $('[data-toggle="tooltip"]').tooltip();
      }, 300);

    },
    methods: {
      filtrarCantidadServicios(e){
        clearTimeout(intervals[e.srcElement.dataset.index])

        intervals[e.srcElement.dataset.index] = setTimeout(() => {
          let index = parseInt(e.srcElement.dataset.index)
          vueAppCheckoutServicios.calcularCantidad(index);
        }, 1000);
      },
      blurInputCantidad(e){
        clearTimeout(intervals[e.srcElement.dataset.index])
        let index = parseInt(e.srcElement.dataset.index)
        this.calcularCantidad(index);
      },
      calcularCantidad(index){
        let cantidad = this.servicios[index].cantidad
        if(cantidad.length > 0){
          cantidad = parseInt(cantidad)
          let modificada = false
          if(cantidad <= 0){
            cantidad = 0
            modificada = true
          }
          if(cantidad > 0){
            if(this.servicios[index].cantidad_min != null &&
              cantidad < this.servicios[index].cantidad_min){
              cantidad = this.servicios[index].cantidad_min
              modificada = true
            }
            else if(this.servicios[index].cantidad_max != null &&
              cantidad > this.servicios[index].cantidad_max){
              cantidad = this.servicios[index].cantidad_max
              modificada = true
            }
          }

          if(modificada){
            this.servicios[index].cantidad = cantidad
          }
        }
        this.actualizarUrl();
      },
      actualizarUrl(){
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let indexParam = 0
        while (params.get("servicios["+indexParam+"]") != null){
          params.delete("servicios["+indexParam+"]")
          indexParam++
        }
        let serviciosAgregado = this.serviciosAgregados
        for (let index in serviciosAgregado){
          params.set("servicios["+index+"]", JSON.stringify({
            servicio_id: serviciosAgregado[index].id,
            cantidad: serviciosAgregado[index].cantidad
          }))
        }
        url.search = params.toString()
        window.history.pushState({}, null, url);
      },
      siguiente(e){
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);
        let keysEliminar = []
        params.forEach((value, name) => {
          if(name.indexOf("servicios") != -1){
            keysEliminar.push(name)
          }
        });
        for(let index in keysEliminar){
          params.delete(keysEliminar[index])
        }
        let serviciosAgregado = this.serviciosAgregados

        for (let index in serviciosAgregado){
          params.set("servicios["+index+"]", JSON.stringify({
            servicio_id: serviciosAgregado[index].id,
            cantidad: serviciosAgregado[index].cantidad
          }))
        }

        location.href = "/checkout/finalizar/" + terrazaJson.slug + "_" + terrazaJson.id + "?" + new URLSearchParams(params).toString()
      },

      restarServicio(index){
        let cantidad = this.servicios[index].cantidad - 1
        if(cantidad <= 0){
          cantidad = 0
          modificada = true
        }

        if(cantidad > 0){
          if(this.servicios[index].cantidad_min != null &&
            cantidad < this.servicios[index].cantidad_min){
            cantidad = this.servicios[index].cantidad_min
            modificada = true
          }
          else if(this.servicios[index].cantidad_max != null &&
            cantidad > this.servicios[index].cantidad_max){
            cantidad = this.servicios[index].cantidad_max
            modificada = true
          }
        }


        this.servicios[index].cantidad = cantidad
      },

      sumarServicio(index){
        let cantidad = this.servicios[index].cantidad + 1
        if(cantidad < 0){
          cantidad = 0
        }

        if(this.servicios[index].cantidad_min != null &&
          cantidad < this.servicios[index].cantidad_min){
          cantidad = this.servicios[index].cantidad_min
          modificada = true
        }
        else if(this.servicios[index].cantidad_max != null &&
          cantidad > this.servicios[index].cantidad_max){
          cantidad = this.servicios[index].cantidad_max
          modificada = true
        }

        if(cantidad == 0){
          cantidad = null
        }

        this.servicios[index].cantidad = cantidad
      }
    }
  });

});
